import repairContentApi from "@/api/repairContentApi";
import { DATE_FORMAT, DATE_FORMAT_JA } from "@/common/constant";
import moment from "moment";
import Face from "./face";
import FloorPlan from "./floor";
import FloorArea from "./floorArea";
import MasterDirection from "./masterDirection";
import Material from "./material";
import Property, { REPAIR_TYPE } from "./property";
import Repair, { REPAIR_METHOD } from "./repair";
import User from "./user";
import Company from "@/model/company";
import contractMoveOutApi from "@/api/contractMoveOutApi";

export interface IRepairContent {
  id: string;
  repair_date: string;
  property_id: string;
  property: Property;
  witness_id: string;
  witness: Company;
  person_in_charge_id: string;
  person_in_charge;
  floor_plan_area_id: string;
  floor_plan_area: FloorArea;
  direction_id: string;
  direction: MasterDirection;
  face_id: string;
  face: Face;
  material_id: string;
  material: Material;
  repair_detail_id: string;
  repair_detail: Repair;
  number_of_depreciation: number;
  remarks: string;
  before_repair: any[];
  after_repair: any[];
  is_latest?: boolean;
  repair_image_id: string;
  floor_plan: FloorPlan;
}
export class RepairContentDTO implements IRepairContent {
  id: string;
  repair_date: string;
  property_id: string;
  property: Property;
  witness_id: string;
  witness: Company;
  person_in_charge_id: string;
  person_in_charge;
  floor_plan_area_id: string;
  floor_plan_area: FloorArea;
  direction_id: string;
  direction: MasterDirection;
  face_id: string;
  face: Face;
  material_id: string;
  material: Material;
  repair_detail_id: string;
  repair_detail: Repair;
  number_of_depreciation: number;
  remarks: string;
  before_repair: any[];
  after_repair: any[];
  floor_plan: FloorPlan;
  check_validate?: boolean;
  is_latest?: boolean;
  repair_image_id: string;
  _id: string; // fake object
  svg_position: any;
  user_created: User;
}

export default class RepairContent extends RepairContentDTO {
  svg_image = null;
  repairContentTemporary: RepairContent[];
  constructor(dto?: RepairContentDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
      dto.property && (this.property = new Property(dto.property));
    } else {
      this.new();
    }
    // calc remain day
    // this.calcRemainDay();
  }

  public new() {
    Object.assign(this, {
      id: null,
      repair_date: "",
      property_id: null,
      witness_id: null,
      witness: new Company(),
      person_in_charge_id: null,
      person_in_charge: new User(),
      floor_plan_area_id: null,
      floor_plan_area: new FloorArea(),
      direction_id: null,
      face_id: null,
      face: new Face(),
      material_id: null,
      material: new Material(),
      repair_detail_id: null,
      repair_detail: "",
      number_of_depreciation: 0,
      remarks: "",
      before_repair: [],
      after_repair: [],
      floor_plan: new FloorPlan(),
      property: new Property(),
      is_latest: true,
    });
  }

  public save() {
    if (this.id) {
      return repairContentApi.update(this);
    } else {
      return repairContentApi.create(this);
    }
  }

  public async remove() {
    return await repairContentApi.remove(this.id);
  }

  public tranformRequest() {
    const dataTranform = Object.assign({}, this);
    dataTranform.after_repair = dataTranform.after_repair.map(
      (item) => item.id
    );
    dataTranform.before_repair = dataTranform.before_repair.map(
      (item) => item.id
    );
    if (dataTranform.check_validate) {
      delete dataTranform.property_id;
    }
    delete dataTranform.property;
    delete dataTranform.repairContentTemporary;

    return dataTranform;
  }

  public async calcRemainDay() {
    console.log('calcRemainDay' , this);
    if (!this.property) {
      this.number_of_depreciation = null;
      return;
    }
    const moveOutDate = await contractMoveOutApi.getMoveOutDateByProperty(this.property.id)
    const hasReset = this.property.repair_contents.find(item => {
      return item.repair_detail.depreciation_method === REPAIR_METHOD.REPAIR_METHOD_RENEW
    });

    if (this.repair_detail && this.material) {
      if (this.property.type === REPAIR_TYPE.UNKNOW_HISTORY
        && !hasReset
        && this.repair_detail.depreciation_method !== REPAIR_METHOD.REPAIR_METHOD_RENEW) {
        // Do not calculate automatically until the next reset
        this.number_of_depreciation = null;
      } else if (this.repair_detail.depreciation_method === REPAIR_METHOD.REPAIR_METHOD_RENEW) {
        this.number_of_depreciation = this.material.num_of_days;
      } else {
        // group by REPAIR_METHOD.REPAIR_METHOD_RENEW
        let lastRepair: any;
        [...this.property.repair_contents, ...this.repairContentTemporary].map(item => {
          if (item.floor_plan_area_id === this.floor_plan_area_id &&
            item.face_id === this.face_id &&
            item.material_id === this.material_id &&
            item.direction_id === this.direction_id &&
            item.is_latest &&
            !((item.id && item.id === this.id) || (item._id && item._id === this._id))) {
            lastRepair = item;
          }
        });
        // case same repair location
        // const lastRepair = repairSameLocation[repairSameLocation.length - 1];
        if (lastRepair) {
          if (moment(this.repair_date).isBefore(lastRepair.repair_date)) {
            this.number_of_depreciation = null;
            return;
          }

          let numberOfDayLastRepair = moment(this.repair_date).diff(lastRepair.repair_date, 'days');
          if (moveOutDate) {
            numberOfDayLastRepair = moment(moveOutDate).diff(lastRepair.repair_date, 'days');
            if (numberOfDayLastRepair > 0) {
              numberOfDayLastRepair = numberOfDayLastRepair - 1
            }
          }

          this.number_of_depreciation = lastRepair.number_of_depreciation - numberOfDayLastRepair;
        } else {
          this.number_of_depreciation = this.material.num_of_days
              - moment(this.repair_date).diff(this.property.date_of_construction, 'days');
        }
        this.number_of_depreciation = this.number_of_depreciation >= 0 ? this.number_of_depreciation : 0;
      }
    }
  }

  get totalDayContruction() {
    return this.material ? this.material.num_of_days : 0;
  }

  get getTitle() {
    const remark = this.remarks ? `（${this.remarks}）` : "";
    return `${this.floor_plan_area.name}/${this.direction.name}/${this.face.name}/${this.material.name} ${this.repair_detail.name} ${this.number_of_depreciation}日/${this.material.num_of_days}日${remark}`;
  }

  get shortTitle() {
    const floorName = this.floor_plan_area ? this.floor_plan_area.name : "";
    return `${floorName}/${this.direction.name}/${this.face.name}/${this.material.name}/${this.repair_detail.name}`;
  }

  get shortTitleWithoutRepair() {
    return `${this.floor_plan_area.name}/${this.direction.name}/${this.face.name}/${this.material.name}`;
  }

  get repairDateFormat() {
    return moment(this.repair_date).format(DATE_FORMAT)
  }

  get repairDateFormatJA() {
    return moment(this.repair_date).format(DATE_FORMAT_JA)
  }

  get latestName() {
    return this.is_latest ? "" : "detail";
  }

  get propertyName() {
    return this.property.name;
  }
  get propertyLocation() {
    return this.property.location.getFullAddress;
  }

  get companyRepair() {
    return this.witness ? this.witness.name : "";
  }
  get personInCharged() {
    return this.person_in_charge ? this.person_in_charge.username : "";
  }
  get createdBy() {
    return this.user_created ? this.user_created.username : "";
  }
}
